export default __webpack_public_path__ + "static/media/علی غفاری.6b303cae.jpg";